<div class="pacote-campanha-filter">
    <div class="pacote-campanha-filter-quick">  
        <div class="pacote-campanha-filter-quick-block pacote-campanha-filter-quick-block-options">
            <!-- Áreas -->
            <div class="pacote-campanha-filter-quick-block-options-multiselect-item">
                <sgt-area-multiselect
                    [(idsAreas)]="filter.idsAreas"
                    (idsAreasChange)="onChangeAreas()"
                    defaultTitle="Áreas"
                    [disabled]="!isFilterInitialized">
                </sgt-area-multiselect>
            </div> 

            <!-- Situações -->
            <div class="pacote-campanha-filter-quick-block-options-multiselect-item">
                <sgt-pacote-campanha-situacao-multiselect
                    [(situacoes)]="filter.situacoes"
                    (situacoesChange)="onChangeSituacoes()"
                    defaultTitle="Situações"
                    [disabled]="!isFilterInitialized">
                </sgt-pacote-campanha-situacao-multiselect>
            </div>

            <div class="pacote-campanha-filter-quick-block-options-filter-psq">
                <input type="text" class="form-control" [(ngModel)]="filter.filterPsq"  #filterPsq="ngModel" name="filterPsq" id="filterPsq" placeholder="Digite para pesquisar...">
            </div>        

            <div class="pacote-campanha-filter-quick-block-options-btns">
                <div class="btn-group">
                    <button type="button" class="btn btn-light" (click)="refresh()" title="Atualizar"
                        [disabled]="!isFilterInitialized">
                        <i class="fas fa-sync"></i>
                    </button>
                    <button type="button" class="btn btn-light" (click)="clear()" title="Limpar filtro e atualizar"
                        [disabled]="!isFilterInitialized">
                        <i class="fas fa-eraser" aria-hidden="true"></i>
                    </button>
                    <button type="button" class="btn" [class.btn-light]="!filter.isFilterDirty" [class.btn-danger]="filter.isFilterDirty"
                        (click)="toggleCollapse()" title="Filtro avançado"
                        [disabled]="!isFilterInitialized">
                        <ng-template [ngIf]="isFilterInitialized">
                            <i class="fas fa-filter" aria-hidden="true"></i>
                            <i [class]="collapseIcon" aria-hidden="true"></i>
                        </ng-template>
                        <ng-template [ngIf]="isFilterInitializing">
                            <i class='fas fa-spinner fa-pulse'></i>
                        </ng-template>
                    </button>
                </div>  
            </div>
        </div>
    </div>

    <div class="pacote-campanha-filter-collapse" #filterCollapse>
        <div class="row">
            <div class="form-group col-12 col-md-6 col-xl-3">
                <label for="tiposPromocoes" class="col-form-label">Tipos de Promoções</label>
                <sgt-tipo-promocao-campanha-multiselect
                    [(tipos)]="filter.tiposPromocoes"
                    (tiposChange)="onChangeTiposPromocoes()"
                    [(nullOption)]="filter.tipoPromocaoNull"
                    [showNullOption]="true">
                </sgt-tipo-promocao-campanha-multiselect>
            </div>             
        </div>        
    </div>
</div>

